"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _callSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/callSuper"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _context = _interopRequireDefault(require("../Theme/context"));
var _context2 = _interopRequireDefault(require("./context"));
var _ImageIcon = _interopRequireDefault(require("../../svg/ImageIcon"));
var _Paper = _interopRequireDefault(require("../Paper"));
var _Wapp = require("wapplr-react/dist/common/Wapp");
var _CircularProgress = _interopRequireDefault(require("../../svg/CircularProgress"));
var _excluded = ["ImageComponent", "classNames", "src", "alt", "width", "height"],
  _excluded2 = ["classNames", "Component", "ComponentProps", "ImageComponent", "className", "src", "width", "height", "ImageIconComponent", "PaperComponent", "PaperComponentProps", "addChildrenPropsToComponent", "showProcessing", "loaded"],
  _excluded3 = ["alt"];
var defaultStyle = require("./../empty_css.js")["default"];
var Img = /*#__PURE__*/function (_React$Component) {
  function Img(props) {
    (0, _classCallCheck2["default"])(this, Img);
    return (0, _callSuper2["default"])(this, Img, [props]);
  }
  (0, _inherits2["default"])(Img, _React$Component);
  return (0, _createClass2["default"])(Img, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextProps.src !== this.props.src;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        ImageComponent = _this$props.ImageComponent,
        classNames = _this$props.classNames,
        src = _this$props.src,
        alt = _this$props.alt,
        width = _this$props.width,
        height = _this$props.height,
        rest = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      return /*#__PURE__*/_react["default"].createElement(ImageComponent, Object.assign({
        className: classNames.image,
        src: src
      }, alt ? {
        alt: alt
      } : {}, {
        width: width,
        height: height
      }, rest));
    }
  }]);
}(_react["default"].Component);
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var context = (0, _react.useContext)(_Wapp.WappContext);
  var wapp = context.wapp;
  var imageContext = (0, _react.useContext)(_context2["default"]);
  var getSrc = imageContext.getSrc,
    getSrcSet = imageContext.getSrcSet;
  var _useContext = (0, _react.useContext)(_context["default"]),
    _useContext$additiona = _useContext.additionalStyles,
    additionalStyles = _useContext$additiona === void 0 ? {} : _useContext$additiona,
    useStyle = _useContext.useStyle;
  var _props$classNames = props.classNames,
    classNames = _props$classNames === void 0 ? additionalStyles.image || defaultStyle : _props$classNames,
    _props$Component = props.Component,
    Component = _props$Component === void 0 ? 'div' : _props$Component,
    _props$ComponentProps = props.ComponentProps,
    ComponentProps = _props$ComponentProps === void 0 ? {} : _props$ComponentProps,
    _props$ImageComponent = props.ImageComponent,
    ImageComponent = _props$ImageComponent === void 0 ? 'img' : _props$ImageComponent,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$src = props.src,
    src = _props$src === void 0 ? '' : _props$src,
    _props$width = props.width,
    width = _props$width === void 0 ? '100%' : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? 'auto' : _props$height,
    _props$ImageIconCompo = props.ImageIconComponent,
    ImageIconComponent = _props$ImageIconCompo === void 0 ? _ImageIcon["default"] : _props$ImageIconCompo,
    _props$PaperComponent = props.PaperComponent,
    PaperComponent = _props$PaperComponent === void 0 ? _Paper["default"] : _props$PaperComponent,
    _props$PaperComponent2 = props.PaperComponentProps,
    PaperComponentProps = _props$PaperComponent2 === void 0 ? {} : _props$PaperComponent2,
    addChildrenPropsToComponent = props.addChildrenPropsToComponent,
    _props$showProcessing = props.showProcessing,
    showProcessing = _props$showProcessing === void 0 ? false : _props$showProcessing,
    _props$loaded = props.loaded,
    loaded = _props$loaded === void 0 ? true : _props$loaded,
    rest2 = (0, _objectWithoutProperties2["default"])(props, _excluded2);
  var _rest2$alt = rest2.alt,
    alt = _rest2$alt === void 0 ? '' : _rest2$alt,
    rest = (0, _objectWithoutProperties2["default"])(rest2, _excluded3);
  if (classNames !== additionalStyles.image) {
    if (typeof useStyle === 'function') {
      useStyle(classNames);
    }
  }
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    error = _useState2[0],
    setError = _useState2[1];
  var _useState3 = (0, _react.useState)(loaded),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    _loaded = _useState4[0],
    setLoaded = _useState4[1];
  function onError() {
    if (!error) {
      setError(true);
    }
  }
  function onLoad() {
    if (!loaded) {
      setLoaded(true);
    }
  }
  var modifiedSrc = getSrc ? getSrc({
    src: src
  }) : src;
  var srcSet = getSrcSet ? getSrcSet({
    srcSet: props.srcSet,
    src: modifiedSrc
  }) : props.srcSet;
  if (!alt && modifiedSrc) {
    try {
      var url = modifiedSrc.split('?')[0];
      var queryString = modifiedSrc.split('?')[1];
      if (queryString) {
        var queryStringParts = queryString.split('&');
        var query = queryStringParts.reduce(function (r, pairs) {
          var _pairs$split = pairs.split('='),
            _pairs$split2 = (0, _slicedToArray2["default"])(_pairs$split, 2),
            key = _pairs$split2[0],
            value = _pairs$split2[1];
          if (key) {
            r[key] = value;
          }
          return r;
        }, {});
        if (query !== null && query !== void 0 && query.alt) {
          alt = query.alt;
        }
      }
      if (!alt) {
        var parts = url.split('/');
        var baseName = parts[parts.length - 1] ? parts[parts.length - 1] : parts[parts.length - 2];
        var fileNameParts = baseName.split('.');
        var fileName = (0, _toConsumableArray2["default"])(fileNameParts.slice(0, -1)).join(' ');
        fileName = fileName.replaceAll('-', ' ');
        fileName = fileName.replaceAll('_', ' ');
        alt = fileName.replaceAll('_', ' ');
      }
    } catch (e) {}
  }
  if (wapp.target !== 'node' && modifiedSrc) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, _react.useLayoutEffect)(function () {
      var testImage = new Image();
      testImage.onerror = onError;
      testImage.onload = onLoad;
      testImage.src = modifiedSrc;
    }, []);
  }
  var _showProcessing = !_loaded && showProcessing;
  return /*#__PURE__*/_react["default"].createElement(Component, Object.assign({
    ref: ref
  }, ComponentProps, {
    className: (0, _clsx["default"])(classNames.root, className, ComponentProps.className)
  }, addChildrenPropsToComponent ? {
    ChildrenProps: (0, _objectSpread2["default"])({
      ImageComponent: ImageComponent,
      classNames: classNames,
      src: modifiedSrc,
      srcSet: srcSet,
      width: width,
      height: height,
      alt: alt,
      error: error,
      loaded: _loaded
    }, rest)
  } : {}), modifiedSrc && !error && !_showProcessing ? /*#__PURE__*/_react["default"].createElement(Img, Object.assign({
    ImageComponent: ImageComponent,
    classNames: classNames,
    className: classNames.image,
    src: modifiedSrc,
    srcSet: srcSet
  }, alt ? {
    alt: alt
  } : {}, {
    width: width,
    height: height
  }, rest)) : /*#__PURE__*/_react["default"].createElement(PaperComponent, Object.assign({
    size: 'none',
    color: 'tertiary',
    variant: 'contained',
    elevation: 0
  }, PaperComponentProps, {
    style: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, typeof width !== 'undefined' && width.match('px') || typeof width !== 'undefined' && width.match('%') ? {
      width: width
    } : {}), typeof height !== 'undefined' && height.match('px') || typeof height !== 'undefined' && height.match('%') ? {
      height: height
    } : {}),
    className: (0, _clsx["default"])(classNames.imageIcon, PaperComponentProps.className)
  }), _showProcessing ? /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], null) : /*#__PURE__*/_react["default"].createElement(ImageIconComponent, null), alt && wapp.globals.DEV ? /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      fontSize: '9px'
    }
  }, alt) : null));
});